// extracted by mini-css-extract-plugin
export default {"HalvesPage":"Halves_HalvesPage__1cT8H"};